import { Box, Tooltip } from "@mui/material";
import React from "react";

const HamburgerMenu = ({ onClick, isOpen }) => {
    return (
        <Tooltip
            title={isOpen ? "Collapse menu" : "Expand menu"}
            placement="right"
            arrow
            componentsProps={{
                tooltip: {
                    sx: {
                        bgcolor: "#2d3748",
                        fontSize: 13,
                        fontWeight: 500,
                        px: 1.5,
                        py: 0.75,
                        "& .MuiTooltip-arrow": {
                            color: "#2d3748",
                        },
                    },
                },
            }}
        >
            <Box
                onClick={onClick}
                sx={{
                    cursor: "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 28,
                    height: 28,
                    borderRadius: 1,
                    "&:hover": { backgroundColor: "#89CFF0" },
                }}
            >
                <Box
                    sx={{
                        width: 16,
                        display: "flex",
                        flexDirection: "column",
                        gap: "3px",
                        "& span": {
                            display: "block",
                            height: 2,
                            backgroundColor: "#718096",
                            borderRadius: 1,
                        },
                    }}
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </Box>
            </Box>
        </Tooltip>
    );
};

export default HamburgerMenu;
